import React from "react"
import { Route, Redirect } from "react-router-dom";

const AuthenticatedRoute = ({ children }) => {
  const loggedIn = localStorage.getItem("loggedIn");
  return loggedIn ? (<Route>{children}</Route>) : <Redirect to={{ pathname: "/" }} />;
};
export default AuthenticatedRoute;